import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import LogoSvg from "../components/LogoSvg";

const Index = () => (
  <main className="min-h-screen bg-white text-black">
    <Helmet>
      <title>OpenPipe</title>
      <meta
        name="description"
        content="The OpenPipe platform has migrated to Weights & Biases and CoreWeave. Browse migration details and the OpenPipe technical archive."
      />
    </Helmet>

    <div className="mx-auto flex min-h-screen w-full max-w-3xl flex-col justify-center px-6 py-20 sm:px-10">
      <LogoSvg className="mb-16 h-auto w-40" linkToHome={false} />

      <div className="space-y-10 text-lg leading-8 sm:text-xl sm:leading-9">
        <p>
          Following our{" "}
          <Link
            to="/blog/openpipe-coreweave"
            className="underline decoration-1 underline-offset-4 hover:text-[#d62600]"
          >
            acquisition by CoreWeave in 2025
          </Link>
          , we successfully migrated OpenPipe's core functionality, including
          model distillation, to the{" "}
          <Link
            to="/blog/openpipe-training-inference-migrating-to-wandb"
            className="underline decoration-1 underline-offset-4 hover:text-[#d62600]"
          >
            CoreWeave platform
          </Link>
          . We also continue to support the open-source{" "}
          <a
            href="https://github.com/OpenPipe/ART"
            className="underline decoration-1 underline-offset-4 hover:text-[#d62600]"
          >
            ART trainer
          </a>
          .
        </p>

        <p>
          We've preserved OpenPipe's technical posts and published research in
          our{" "}
          <Link
            to="/blog"
            className="underline decoration-1 underline-offset-4 hover:text-[#d62600]"
          >
            blog archive
          </Link>
          .
        </p>
      </div>
    </div>
  </main>
);

export default Index;
